































import { Prop, Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'SwatchTraitPreview',
  filters: {
    convertToHex(value: number) {
      return `#${value.toString(16)}`;
    },
  },
})
export default class SwatchTraitPreview extends Vue {
  @Prop(String) readonly categoryKey: string | undefined;
  @Prop(Number) readonly colorTone: number | undefined;
  @Prop(Boolean) readonly isSelected: boolean | undefined;
  @Prop(Boolean) readonly tabNavigationEnabled: boolean | undefined;

  get borderRadius(): string {
    return '8px';
  }
}
